<div class="modal">
  <div class="container model-container {{data.customClass}}">
    <img src="assets/icon/popup-close-icon.svg" (click)="closeDialog()" class="close-icon" width="32" height="32"
      alt="Close Icon">
    <div class="modal-header">
      <h4 class="modal-heading">{{showVerificationForm ? 'Verify your New Email' : 'Update your Email'}}</h4>
    </div>
    <div class="modal-body">
      <ng-container *ngIf="!showVerificationForm">
        <div class="modal-content">
          <p class="smaller text-content">Enter your new email and current password to proceed:</p>

          <form [formGroup]="emailForm">
            <label class="outlined-input">
              <input type="text" formControlName="email" placeholder=" ">
              <span>New Email <span class="star hide">*</span></span>
            </label>

            <p *ngIf="emailForm.controls.email.touched && emailForm.controls.email.hasError('required')"
              class="validation-message">
              First Name is required
            </p>
            <p *ngIf="emailForm.controls.email.touched && emailForm.controls.email.hasError('pattern')"
              class="validation-message">
              Invalid email. Try again!
            </p>

            <label class="outlined-input second">
              <input (input)="credentialsError = false" [type]="showPassword ? 'text' : 'password'"
                formControlName="password" placeholder=" " autocomplete="new-password">
              <span>Password <span class="star hide">*</span></span>

              <img class="eye" [src]="showPassword ? 'assets/icon/eye-slash.svg' :'assets/icon/grey-eye-icon.svg'"
                (click)="showPassword = !showPassword" *ngIf="emailForm.controls.password.value" alt="eye icon"
                height="16" width="16">
            </label>

            <p *ngIf="emailForm.controls.password.touched && emailForm.controls.password.hasError('required')"
              class="validation-message">
              Confirm Password is required
            </p>
            <p *ngIf="credentialsError" class="validation-message">
              Invalid password. Try again!
            </p>
          </form>
        </div>

        <div class="modal-actions">
          <button class="button primary" (click)="updateEmail()">update</button>
          <button class="button tertiary" (click)="cancel()">Cancel</button>
        </div>
      </ng-container>

      <ng-container *ngIf="showVerificationForm">
        <div class="modal-content">
          <p class="smaller text-content">A verification code has been sent to: <b>{{emailForm.controls.email.value}}</b></p>

          <form [formGroup]="verifyForm" class="chars-form"
            [class.invalid]="(!!enteredCode && !isValid) || (form?.touched && !enteredCode) || (!!enteredCode && !!incorrectCode) ">
            <div class="input-container">
              <input type="text" formControlName="char1" maxlength="1" (input)="onInput($event, char2)"
                (keydown)="onBackspace($event, char1)" #char1 class="char-input" />
              <input type="text" formControlName="char2" maxlength="1" (input)="onInput($event, char3)"
                (keydown)="onBackspace($event, char1)" #char2 class="char-input" />
              <input type="text" formControlName="char3" maxlength="1" (input)="onInput($event, char4)"
                (keydown)="onBackspace($event, char2)" #char3 class="char-input" />
              <input type="text" formControlName="char4" maxlength="1" (input)="onInput($event, char5)"
                (keydown)="onBackspace($event, char3)" #char4 class="char-input" />
              <input type="text" formControlName="char5" maxlength="1" (input)="onInput($event, char6)"
                (keydown)="onBackspace($event, char4)" #char5 class="char-input" />
              <input type="text" formControlName="char6" maxlength="1" (keydown)="onBackspace($event, char5)" #char6
                class="char-input" />
            </div>

            <label class="validation-message" *ngIf="verifyForm?.touched && !enteredCode" id="required-msg">
              Verification code is required.
            </label>
            <label class="validation-message"
              *ngIf="verifyForm?.dirty && !!enteredCode && (!isValid || enteredCode?.length < 6)" id="wrong-code">
              Wrong code. Verification code must be 6 characters.
            </label>
            <label class="validation-message" *ngIf="verifyForm?.dirty && !!enteredCode && !!incorrectCode"
              id="invalid-code">
              Invalid code. Please try again.
            </label>
            <label class="validation-message" *ngIf="verifyForm?.dirty && !!enteredCode && expiredCode"
              id="expired-code">
              Expired code. Please request a new one.
            </label>
          </form>
        </div>

        <div class="modal-actions verification">
          <button class="button primary" (click)="verifyCode()">Verify</button>
          <button class="button secondary" (click)="handleEmailVerification()" [disabled]="timeLeft > 0">
            Resend Code <span *ngIf="timeLeft > 0" class="mins"><b>{{minutes}}:{{seconds}}</b></span>
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>
